export default function storesTabs() {
  const tabs = document.querySelectorAll('.section-stores [data-tab]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      let targets = document.querySelectorAll(`.${tab.dataset.target}`);
      let activeContents = document.querySelectorAll('.section-stores .-active');

      activeContents.forEach((activeContent) => {
        activeContent.classList.remove('-active');
      });

      targets.forEach((target) => {
        target.classList.add('-active');
      });
    });
  });
}
